export default __webpack_public_path__ + "static/banner-cloud-57f45c521f0905bdeb3b879514e8b47e.png";